// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"IntegrationIcon-primaryButton-2eiJNu","cardIcon":"IntegrationIcon-cardIcon-1LlwNd"};